import { render } from "./ClientNavBar.vue?vue&type=template&id=82bcd8a8&scoped=true"
import script from "./ClientNavBar.vue?vue&type=script&lang=js"
export * from "./ClientNavBar.vue?vue&type=script&lang=js"

import "./ClientNavBar.vue?vue&type=style&index=0&id=82bcd8a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82bcd8a8"]])

export default __exports__